import React, { FC, CSSProperties } from 'react'

const TestPage: FC = () => {
 return (
  <div>
   Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta quae
   perferendis et assumenda corporis corrupti sint, voluptate adipisci!
   Recusandae commodi officiis magni dignissimos saepe consectetur rerum
   necessitatibus. Doloremdddddddddddddddddddddddddddddddddddddddddque
   temporibus minima aliquam, consequuntur nam ex
  </div>
 )
}

export default TestPage
